import { useTheme } from "../../../context/useThemeContext";
import { FaLink } from "react-icons/fa";
import { RiTextBlock } from "react-icons/ri";
import { useGetEditor } from "../../../context/useEditorContext";
import useAbsoluteWindowStore from "../../../stores/absoluteWindowStore";
import { TopButton } from "./TopButton";
import TextAlterations from "./textAlterations";
import { Seperator } from "./Seperator";
import { TextLists } from "./textLists";
import { TextIndent } from "./textIndent";
import TextRightContent from "./textRightContent";
import { HeaderSelection } from "./HeaderSelection";
import { RemoveFormatting } from "./RemoveFormatting";
import { IconsContainer } from "./IconsContainer";
import { useEffect, useState } from "react";

function RichTextHeader() {
    const { theme } = useTheme();
    const editor = useGetEditor().editor.current;

    const [textSelected, setTextSelected] = useState(false);

    useEffect(() => {
        if (editor) {
            const updateSelection = () => {
                setTextSelected(!editor.state.selection.empty);
            };

            updateSelection();

            editor.on("selectionUpdate", updateSelection);

            return () => {
                editor.off("selectionUpdate", updateSelection);
            };
        } else {
            setTextSelected(false);
        }
    }, [editor]);

    return (
        <div
            className="flex px-3 "
            style={{
                backgroundColor: theme.secondaryHeaderColor,
                color: theme.fontColor[200],
            }}
        >
            <div className="min-h-[34px] py-1 w-full text-[12px] flex items-center gap-2 flex-wrap shirink-0">
                <TextAlterations />
                <TextLists />
                <TextIndent />
                <HeaderSelection />

                {/* Other */}
                <RemoveFormatting />
                {/* Textblock */}
                {/* <IconsContainer>
                    <TopButton
                        alt="Textblock"
                        icon={<RiTextBlock size={16} />}
                        onClick={(e) => {
                            console.error("Implement Textblock");

                            editor?.commands.focus();
                        }}
                    />
                    <Seperator />
                </IconsContainer> */}
                {/* Link */}
                <IconsContainer>
                    <TopButton
                        alt="Link"
                        icon={<FaLink size={14} />}
                        isDisabled={!textSelected}
                        onClick={(e) => {
                            useAbsoluteWindowStore
                                .getState()
                                .showTextMenu(editor);
                        }}
                    />
                </IconsContainer>
            </div>
            {/* Spacer to make the right content align to the right */}
            <div className="spacer flex flex-1" />
            {/* Undo / Redo / Table of Contents */}
            <TextRightContent />
        </div>
    );
}
export default RichTextHeader;
